import '../../roundhouse/plugins/console.js';
import '../../roundhouse/plugins/jquery.debounce.js';
import '../../roundhouse/plugins/jquery.tab-group.js';
import '../../roundhouse/plugins/jquery.tab-to-expander-helper.js';
import ClipboardJS from '../../vendor/clipboard.js';
import '../../roundhouse/plugins/jquery.is-welsh-page.js';
import '../../roundhouse/plugins/jquery.adaptive-navigation.js';
import '../../vendor/plugins/jquery.ba-bbq.js';
import '../../roundhouse/plugins/jquery.event-alert.js';
import '../../roundhouse/plugins/jquery.eventify.js';
import '../../roundhouse/plugins/jquery.expander.js';
import '../../roundhouse/plugins/jquery.fix-slick-slider-button-translations.js';
import iFrameResize from '../../vendor/plugins/jquery.iframeResizer.js';
import '../../roundhouse/plugins/jquery.iframe-lazy-load.js';
import '../../roundhouse/plugins/jquery.iframe-dotdigital-title-injector.js';
import '../../roundhouse/plugins/jquery.iframe-youtube-title-injector.js';
import '../../roundhouse/plugins/jquery.table-accessibility.js';
import '../../vendor/plugins/jquery.jBreadCrumb.1.1.js';
import 'magnific-popup';
import '../../roundhouse/plugins/jquery.sliding-featured-image-group.js';
import '../../roundhouse/plugins/jquery.su-datepicker.js';
import '../../vendor/modernizr.js';
import 'slick-carousel';
// import '../../vendor/typeahead.bundle.js';
// import '../../../../node_modules/handlebars/dist/handlebars.js';
// import '../../vendor/plugins/funnelback.autocompletion-2.6.0.js';
import '../../vendor/plugins/jquery.autocomplete.js';
import '../../vendor/plugins/jquery.sticky.js';
import '../../vendor/reciteme.js';
import 'pannellum';

import addAsterisksToRequiredFormFields from '../es-modules/add-asterisks-to-required-form-fields.mjs';
import addStickyNavBarAndCourseCTA from '../es-modules/add-sticky-nav-bar-and-course-cta.mjs';
import awardSliderGroup from '../es-modules/award-slider-group.mjs';
import cookieWidgetA11y from '../es-modules/cookie-widget-ally.mjs';
import enhanceContextualNav from '../es-modules/enhance-contextual-nav.mjs';
import executeInjectedScripts from '../es-modules/execute-injected-scripts.mjs';
import hideAndShowMobileSearch from '../es-modules/hide-and-show-mobile-search.mjs';
import hideShowContextualNav from '../es-modules/hide-show-contextual-nav.mjs';
import hideShowSuImageHeadingStraplineBackground from '../es-modules/hide-show-su-image-heading-strapline-background.mjs';
import lightbox from '../es-modules/lightbox.mjs';
import makeSilktideIgnoreCookiebotDialog from '../es-modules/make-silktide-ignore-cookiebot-dialog.mjs';
import maybeEnhanceBreadcrumb from '../es-modules/maybe-enhance-breadcrumb.mjs';
import photoGallery from '../es-modules/photo-gallery.mjs';
import preventFormMailSpam from '../es-modules/prevent-form-mail-spam.mjs';
import relatedActionsLink from '../es-modules/related-actions-link.mjs';
import responsiveIframes from '../es-modules/responsive-iframes.mjs';
import searchToggle from '../es-modules/search-toggle.mjs';
import sliderGroup from '../es-modules/slider-group.mjs';
import smoothScrollToElement from '../es-modules/smooth-scroll-to-element.mjs';
import vimeoRefreshForVimeoPopups from '../es-modules/vimeo-refresh-for-vimeo-popus.mjs';

// Prevent jQuery from clashing with other libraries that use the $ alias
jQuery.noConflict();

window.ClipboardJS = ClipboardJS;

(function($) {
    $('.navbar-nav').adaptiveNavigation();
    $('.sliding-featured-image-group').slidingFeaturedImageGroup();
    $('.slick-slider').fixSlickSliderButtonTranslations();
    $('form.su-form input.su-datepicker').suDatePicker();
    $('.event-card').eventify();
    $('.event-alert').eventAlert();
    $('.expander-item').expander();
    $('iframe.iframe-lazy-load').iframeLazyLoad().on('load', function() {
        iFrameResize({ log: true }, this);
    });
    $("iframe[src*='www.youtube.com']").iframeYouTubeTitleInjector();
    $("iframe[src*='dotdigital-pages.com']").iframeDotDigitalTitleInjector();
    $('table').not('.su-embed-code table').not('.no-table-ally').tableAccessibility();
    $('.su-tabs, .course-details-content-key-details-tabs').tabGroup();
    $('.tab-expander-content-panel').tabToExpanderHelper();

    maybeEnhanceBreadcrumb();
    enhanceContextualNav();
    hideShowContextualNav();
    hideAndShowMobileSearch();
    hideShowSuImageHeadingStraplineBackground();
    lightbox();
    makeSilktideIgnoreCookiebotDialog();
    vimeoRefreshForVimeoPopups();
    sliderGroup();
    awardSliderGroup();
    photoGallery();
    addAsterisksToRequiredFormFields();
    preventFormMailSpam();
    responsiveIframes();
    cookieWidgetA11y();
    relatedActionsLink();
    searchToggle();
    smoothScrollToElement();

    executeInjectedScripts();

    $(window).on('scroll', function() {
        addStickyNavBarAndCourseCTA();
    });
})(jQuery);
